import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { zodResolver } from '@hookform/resolvers/zod';
import Button from '@shape-construction/arch-ui/src/Button';
import InputTextArea from '@shape-construction/arch-ui/src/Form/TextArea';
import Modal from '@shape-construction/arch-ui/src/Modal';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { z } from 'zod';
import { AppVersion } from './AppVersion';
const CrashReport = t0 => {
  const $ = _c(59);
  const {
    onClose,
    onSubmit
  } = t0;
  const {
    t
  } = useTranslation();
  let t1;
  let t2;
  if ($[0] !== t) {
    const requiredFieldMessage = t("errors.requiredField");
    const crashReportSchema = z.object({
      description: z.string().min(1, requiredFieldMessage)
    });
    t2 = useForm;
    t1 = zodResolver(crashReportSchema);
    $[0] = t;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      description: ""
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t1) {
    t4 = {
      resolver: t1,
      defaultValues: t3
    };
    $[4] = t1;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const form = t2(t4);
  const {
    register,
    handleSubmit
  } = form;
  let T0;
  let T1;
  let T2;
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[6] !== handleSubmit || $[7] !== onClose || $[8] !== onSubmit || $[9] !== register || $[10] !== t) {
    const submitFeedback = values => {
      const {
        description
      } = values;
      onSubmit({
        description
      });
      handleCloseModal();
    };
    const handleCloseModal = () => {
      onClose();
    };
    T2 = Modal.Root;
    t11 = true;
    t12 = handleCloseModal;
    let t15;
    if ($[24] !== t) {
      t15 = t("crashReport.title");
      $[24] = t;
      $[25] = t15;
    } else {
      t15 = $[25];
    }
    let t16;
    if ($[26] !== t15) {
      t16 = <Modal.Title>{t15}</Modal.Title>;
      $[26] = t15;
      $[27] = t16;
    } else {
      t16 = $[27];
    }
    t13 = <Modal.Header onClose={handleCloseModal}>{t16}</Modal.Header>;
    const t17 = handleSubmit(submitFeedback);
    let t18;
    if ($[28] !== t) {
      t18 = t("crashReport.description.label");
      $[28] = t;
      $[29] = t18;
    } else {
      t18 = $[29];
    }
    let t19;
    if ($[30] !== register) {
      t19 = register("description");
      $[30] = register;
      $[31] = t19;
    } else {
      t19 = $[31];
    }
    let t20;
    if ($[32] !== t18 || $[33] !== t19) {
      t20 = <InputTextArea data-hj-allow={true} label={t18} rows={6} {...t19} />;
      $[32] = t18;
      $[33] = t19;
      $[34] = t20;
    } else {
      t20 = $[34];
    }
    let t21;
    if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
      t21 = <div className="pt-8 pb-4"><AppVersion /></div>;
      $[35] = t21;
    } else {
      t21 = $[35];
    }
    t14 = <Modal.Content className="flex p-4"><form className="space-y-6" onSubmit={t17}>{t20}</form>{t21}</Modal.Content>;
    T1 = Modal.Footer;
    let t22;
    if ($[36] !== t) {
      t22 = t("crashReport.cancelCTA");
      $[36] = t;
      $[37] = t22;
    } else {
      t22 = $[37];
    }
    t10 = <Button color="secondary" variant="outlined" size="md" onClick={handleCloseModal}>{t22}</Button>;
    T0 = Button;
    t5 = "primary";
    t6 = "contained";
    t7 = "md";
    t8 = "submit";
    t9 = handleSubmit(submitFeedback);
    $[6] = handleSubmit;
    $[7] = onClose;
    $[8] = onSubmit;
    $[9] = register;
    $[10] = t;
    $[11] = T0;
    $[12] = T1;
    $[13] = T2;
    $[14] = t10;
    $[15] = t11;
    $[16] = t12;
    $[17] = t13;
    $[18] = t14;
    $[19] = t5;
    $[20] = t6;
    $[21] = t7;
    $[22] = t8;
    $[23] = t9;
  } else {
    T0 = $[11];
    T1 = $[12];
    T2 = $[13];
    t10 = $[14];
    t11 = $[15];
    t12 = $[16];
    t13 = $[17];
    t14 = $[18];
    t5 = $[19];
    t6 = $[20];
    t7 = $[21];
    t8 = $[22];
    t9 = $[23];
  }
  let t15;
  if ($[38] !== t) {
    t15 = t("crashReport.submitCTA");
    $[38] = t;
    $[39] = t15;
  } else {
    t15 = $[39];
  }
  let t16;
  if ($[40] !== T0 || $[41] !== t15 || $[42] !== t5 || $[43] !== t6 || $[44] !== t7 || $[45] !== t8 || $[46] !== t9) {
    t16 = <T0 color={t5} variant={t6} size={t7} type={t8} onClick={t9}>{t15}</T0>;
    $[40] = T0;
    $[41] = t15;
    $[42] = t5;
    $[43] = t6;
    $[44] = t7;
    $[45] = t8;
    $[46] = t9;
    $[47] = t16;
  } else {
    t16 = $[47];
  }
  let t17;
  if ($[48] !== T1 || $[49] !== t10 || $[50] !== t16) {
    t17 = <T1>{t10}{t16}</T1>;
    $[48] = T1;
    $[49] = t10;
    $[50] = t16;
    $[51] = t17;
  } else {
    t17 = $[51];
  }
  let t18;
  if ($[52] !== T2 || $[53] !== t11 || $[54] !== t12 || $[55] !== t13 || $[56] !== t14 || $[57] !== t17) {
    t18 = <T2 open={t11} onClose={t12}>{t13}{t14}{t17}</T2>;
    $[52] = T2;
    $[53] = t11;
    $[54] = t12;
    $[55] = t13;
    $[56] = t14;
    $[57] = t17;
    $[58] = t18;
  } else {
    t18 = $[58];
  }
  return t18;
};
export default CrashReport;